import { instance } from '../../api/setup'

// initial state
const state = {
  account: null
}

// getters
const getters = {
  account: state => state.account
}

// actions
const actions = {
  getActiveAccount ({ commit }) {
    return new Promise((resolve, reject) => {
      instance({ url: '/account', method: 'GET' }).then(resp => {
        commit('account', resp.data)
        resolve(resp)
      }).catch(err => {
        reject(err)
      })
    })
  },
  changeActiveAccount ({ commit }, account) {
    return new Promise((resolve, reject) => {
      commit('account', account)
      resolve()
    })
  }
}

// mutations
const mutations = {
  account (state, account) {
    state.account = account
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
